import { MOBILE_BREAKPOINT_PX, useMediaQuery } from '@/hooks/useBreakpoint';

export const ASSISTANT_DOCK_MIN_PX = 1280;

export type AssistantPresentation = 'docked' | 'overlay' | 'sheet';

/** Desktop docks the panel, tablet overlays it, phones use a sheet. */
export function useAssistantPresentation(): AssistantPresentation {
  const isDock = useMediaQuery(`(min-width: ${ASSISTANT_DOCK_MIN_PX}px)`);
  const isTablet = useMediaQuery(`(min-width: ${MOBILE_BREAKPOINT_PX}px)`);
  if (isDock) return 'docked';
  if (isTablet) return 'overlay';
  return 'sheet';
}
